import React, { useEffect } from 'react';
import { Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import Lottie from 'lottie-react'; // Add this import
import animationData from '../assets/json/Animation - 1742883666095.json'; // You'll need to add your Lottie JSON file
export default function ThankYou() {
  const navigate = useNavigate();
  const handleBackToHome = () => {
    navigate('/');
  };
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div 
      style={{ 
        minHeight: '60vh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '20px',
        textAlign: 'center'
      }}
    >
      {/* Add Lottie animation here */}
      <Lottie 
        animationData={animationData}
        loop={true}
        style={{
          width: '300px', // Adjust size as needed
          height: '300px',
          marginBottom: '20px'
        }}
      />
      <h1 
        style={{ 
          color: '#00a6a2',
          fontSize: '2.5rem',
          marginBottom: '20px',
          fontFamily: 'Arial, sans-serif'
        }}
      >
        Thank You!
      </h1>
      <p 
        style={{ 
          color: '#0d7878',
          fontSize: '1.2rem',
          marginBottom: '30px',
          maxWidth: '500px',
          fontFamily: 'Arial, sans-serif'
        }}
      >
        Thank you for Filling the Form. We'll get back to you soon with confirmation details.
      </p>
      <Button
        variant="contained"
        onClick={handleBackToHome}
        sx={{ 
          backgroundColor: '#00a6a2',
          fontWeight: '500',
          padding: '10px 20px',
          '&:hover': {
            backgroundColor: '#008c8a'
          }
        }}
      >
        Back to Home
      </Button>
    </div>
  );
}